import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { TokenStorageService } from "@app/core/services/token-storage.service";

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private tokenStorage: TokenStorageService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.tokenStorage.getToken();

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next.handle(request).pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const isUserEndpoint = request.url.endsWith('/secured/user');
            if (
              isUserEndpoint &&
              event.body &&
              event.body.warnings &&
              Array.isArray(event.body.warnings) &&
              event.body.warnings.includes("EMPTY_BIRTHDAY")
            ) {
              return;
            }
            this.tokenStorage.clearToken();
          }
        })
      );
    }

    return next.handle(request);
  }
}
